import axios from "axios";
import httpStatus from "http-status";
import { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import server from "../environment";

export const AuthContext = createContext({});

const client = axios.create({
  baseURL: `${server}/api/v1/users`,
});

export const AuthProvider = ({ children }) => {
  const authContext = useContext(AuthContext);
  
  const [userData, setUserData] = useState(authContext);
  
  const router = useNavigate();
  
  const handleRegister = async (name, username, password) => {
    try {
      let request = await client.post("/register", {
        name,
        username,
        password,
      });
      
      if (request.status === httpStatus.CREATED && request.data) {
        return request.data.message;
      }
    } catch (err) {
      console.error("Registration error:", err.message || err);
      throw err; // Make sure to throw the error so it can be caught by the caller
    }
  };

  const handleLogin = async (username, password) => {
    try {
      // Optional: Show a loading indicator here
      let request = await client.post("/login", {
        username,
        password
      });
        
      // Check if the login request was successful
      if (request.status === httpStatus.OK && request.data) {
        // First set the token
        localStorage.setItem("token", request.data.token);
        
        // Add a small delay before navigation to ensure localStorage is updated
        // This helps prevent the 404 issue in production environments
        setTimeout(() => {
          router("/home");
        }, 100);
        
        return request.data;
      } else {
        console.error("Login failed:", request.statusText);
        throw new Error("Login failed");
      }
    } catch (err) {
      console.error("Login error:", err.message || err);
      throw err; // Make sure to re-throw the error so the Authentication component can handle it
    }
  };
    
  const getHistoryOfUser = async () => {
    try {
      let request = await client.get("/get_all_activity", {
        params: {
          token: localStorage.getItem("token"),
        },
      });
      return request.data;
    } catch (err) {
      throw err;
    }
  };
  
  const addToUserHistory = async (meetingCode) => {
    try {
      let request = await client.post("/add_to_activity", {
        token: localStorage.getItem("token"),
        meeting_code: meetingCode,
      });
      return request;
    } catch (e) {
      throw e;
    }
  };
  
  const data = {
    userData,
    setUserData,
    addToUserHistory,
    getHistoryOfUser,
    handleRegister,
    handleLogin,
  };
  
  return <AuthContext.Provider value={data}>{children}</AuthContext.Provider>;
};